import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const CesStcwDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsCesStcwDetails" */ 'modules/activityDetails/CesStcwDetails/pages/CesStcwDetails'
    )
)

const CesStcwDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={`${routes.root}/:cesId/:activityId`} component={CesStcwDetails} />
      <Route exact path={`${routes.root}/:cesId`} component={CesStcwDetails} />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default CesStcwDetailsRouting
